import { FullContainer } from '@gorila-shared-ui/components';
import { useStyles } from '../../../hooks/useStyles';
import MaintenanceConfigurationList from '../../maintenances/configurations/MaintenaceConfigurationList';
import MaintenanceConfigurationsFiltersBar from '../../maintenances/configurations/MaintenanceConfigurationsFiltersBar';

function MaintenanceConfigurationsPage() {
  const { classes } = useStyles();

  return (
    <FullContainer
      verticalFlex
      classNames={classes.basicPageContainer}
    >
      <MaintenanceConfigurationsFiltersBar />
      <MaintenanceConfigurationList />
    </FullContainer>
  );
}

export default MaintenanceConfigurationsPage;
